<template>
  <v-app class="grn" id="app">
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>
<style scoped>
  #app {
    background-color: var(--v-background-base);
  }
  .grn {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-family: 'Roboto', sans-serif;
  }
</style>
<script>
import { Hub } from 'aws-amplify'

export default {
  name: 'App',
  mounted () {
    Hub.listen('auth', ({ payload }) => {
      switch (payload.event) {
        case 'signIn':
          this.$router.push('/').catch(() => {})
          break
        case 'signOut':
          this.$router.push('signin').catch(() => {})
          break
        default:
          break
      }
    })
  },
  watch: {
    $route: {
      // eslint-disable-next-line vue/no-arrow-functions-in-watch
      handler: () => {
        document.title = 'BetMakers Reporting'
      },
      immediate: true
    }
  }
}
</script>
